import { useInteractiveState, WithInteractiveState } from './useInteractiveState';

/**
 * The `Interactive` API is designed to concisely express a interactive pattern in a performant way.
 */
export const Interactive = {
    /** Listen to the interaction on an element. */
    useInteractiveState,
    WithInteractiveState,
};
